// extracted by mini-css-extract-plugin
export default {"productGrid":"i2-z","centerLink":"j2-z","productSection":"k2-z","item":"l2-z","ctaButton":"m2-z"};